import * as Yup from 'yup';

const validationSchema = () => {
  return Yup.object().shape({
    email: Yup.string()
      // .email('validation/email-format') - default email validation doesn't work properly
      .matches(
        /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        'emailAddressInput.validationError.emailNotValid'
      ) // t('emailAddressInput.validationError.emailNotValid') <- for i18n-unused
      .required('emailAddressInput.validationError.fieldEmpty'), // t('emailAddressInput.validationError.fieldEmpty') <- for i18n-unused
    password: Yup.string()
      .required('passwordInput.validationError.fieldEmpty') // t('passwordInput.validationError.fieldEmpty') <- for i18n-unused
      .min(6, 'passwordInput.validationError.passwordMinLength'), // t('passwordInput.validationError.passwordMinLength') <- for i18n-unused
  });
};

export default validationSchema;
